<div class="content-box">
    <h2 class="header-major">Page not found</h2>
    <p>We couldn't find the page you were looking for. Do you have the right URL?</p>
</div>